import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const popularScience: Array<RouteConfig> = [
    {
        path: 'data-manage/popular-science',
        name: 'popularScience',
        redirect: { name: 'popularScienceSettings' },
        meta: {
            menuMatch: 'popularScienceSettings',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'settings',
                name: 'popularScienceSettings',
                component: () => import(`@/${BASE_PATH}/popularScience/PopularScience.vue`),
                meta: {
                    index: '7',
                },
            },
            {
                path: 'detail',
                name: 'popularScienceDetail',
                component: () => import(`@/${BASE_PATH}/popularScience/PopularScienceDetail.vue`),
                meta: {
                    index: '7',
                },
            },
        ],
    },
];
export default popularScience;